import React from 'react';
import styled from 'styled-components';
import {INVOICE_DIRECTIONS} from "../../../../Invoices/constants";

const Label = styled.span`
  padding: 2px 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
  display: inline-block;
  white-space: nowrap;
  margin: 10px;
  width: 150px;
  background-color: ${props => {
  if (props.color) {
    return props.color;
  }

  if (props.direction == INVOICE_DIRECTIONS.INCOMING) {
    return '#10B17E';
  }
  if (props.direction == INVOICE_DIRECTIONS.OUTGOING) {
    return '#0183D5';
  }

  return '#10B17E';
}};
`;

export const InvoiceDirectionLabel = ({ children, direction, onClick, color, plannable }) => {
  return (
    <Label direction={direction}>
      {children}
    </Label>
  );
};
